import React, { FunctionComponent, useEffect, useRef, useState, } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./DateInput.module.css";
import Label from "../Label";

type DateInputProps = {
    mode: "date" | "time" | "datetime"; // Mode determines input type
    onChange: (value: string) => void; // Callback for value change
    value?: string; // Initial value (ISO format)
    label?: string;
    dateDisabled?:boolean;
};

const DateInput: React.FC<DateInputProps> = ({ mode, value, onChange, label,dateDisabled }) => {
    const [inputValue, setInputValue] = useState<string>(value || "");
    // Determine input type based on mode
    const inputType = mode === "date" ? "date" : mode === "time" ? "time" : "datetime-local";

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column",width:"100%" }}>
            {label && (
                <p style={{ marginBottom: "0.25rem" }}>{label}</p>
            )}
            <div className={styles.dateInput}>
                <input
                    type={inputType}
                    value={inputValue}
                    onChange={handleChange}
                    style={{
                        border: "none",
                        outline: "none",
                        width: "100%",
                        fontSize: "1rem",
                    }}
                    disabled={dateDisabled ? dateDisabled : false}     
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
    };
};

export default connect(mapStateToProps)(DateInput);
